

import React from 'react';
import { List, Badge, Card } from 'antd';


const colorMap = {
  PR: "#1677FF",     // Blue
  RFX: "#722ED1",    // Purple
  PO: "#13A8A8",     // Teal
  INV: "#FA8C16",    // Orange
  COMM: "#52C41A",   // Green
  SM: "#EB2F96",     // Pink
  GRN: "#2F54EB",    // Indigo
  SES: "#08979C",    // Cyan
  TECH: "#D46B08",   // Dark Orange
  All: "#595959",    // Grey
};

const labelMap = {
  PR: "PR Approval",
  RFX: "RFQ Approval",
  PO: "PO Approval",
  INV: "Invoice Approval",
  COMM: "Commercial Approval",
  SM: "Vendor Approval",
  GRN: "GRN Approval",
  SES: "SES Approval",
  TECH: "Technical Approval",
};

const ActionCenter = ({ actions = [] }) => {
  return (
    <Card
      title="My Action Center"
      // extra={
      //   <a href="#viewall" style={{ fontWeight: "bold" }}>
      //     View All
      //   </a>
      // }
      style={{
        width: "100%",
        maxWidth: 360,
        height: 450, // Fixed height
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      }}
      bodyStyle={{
        padding: "0 16px",
        height: 360,       // Fixed body height
        overflowY: "auto", // Enable vertical scroll
      }}
    >
      <List
        // dataSource={actions.filter(item => item.businessComponentId !== "All")}

        dataSource={actions.filter(
          item => item.businessComponentId !== "All" && item.count > 0
        )}
        renderItem={(item) => (
          <List.Item
            style={{ cursor: "pointer", padding: "12px 4px" }}
            actions={[
              // <Badge
              //   count={item.count}
              //   showZero
              //   style={{
              //     backgroundColor:
              //       colorMap[item.businessComponentId] || "#1677ff",
              //     borderRadius: "5px",
              //   }}
              // />
              <Badge
                count={item.count}
                // showZero
                style={{
                  backgroundColor: colorMap[item.businessComponentId] || "#1677FF",
                  color: "#fff",
                  borderRadius: "6px",
                  fontWeight: 600,
                  minWidth: 26,
                  height: 22,
                  lineHeight: "22px",
                  padding: "0 8px",
                }}
              />
            ]}
          >
            <span
              style={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#262626",
              }}
            >
              {/* {`${item.businessComponentDesc} Approval`} */}
              {labelMap[item.businessComponentId] || `${item.businessComponentDesc} Approval`}
            </span>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default ActionCenter;